module.exports = __webpack_public_path__ + "assets/img/1bd0d4ae1bbac7b6cea05e1cb8ca02af.svg";